<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">Yeni Randevu</div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Customer Name -->
        <q-select
          filled
          :model-value="customerId"
          use-input
          fill-input
          emit-value
          map-options
          stack-label
          hide-selected
          input-debounce="0"
          :options="customerOpt"
          option-label="name"
          option-value="id"
          hint="Danisan ismi ile arama yapabilirsiniz."
          @filter="filterFn"
          @input-value="onCustomerSelect"
        >
        </q-select>

        <!-- Customer's Active Subscription Info -->
        <q-banner v-if="activeSubscriptionInfo" class="text-white bg-info">
          {{ activeSubscriptionInfo }}
        </q-banner>

        <!-- Appointment Type -->
        <q-select
          v-model="appointmentType"
          filled
          :options="appointmentOpt"
          label="Randevu Turu"
        />

        <!-- Appointment Date -->
        <q-input v-model="appointmentDate" filled label="Randevu Gunu">
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date v-model="appointmentDate" mask="DD-MM-YYYY">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment Start Time -->
        <q-input
          v-model="appointmentStart"
          filled
          label="Randevu Baslangic Saati"
        >
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time v-model="appointmentStart" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment End Time -->
        <q-input v-model="appointmentEnd" filled label="Randevu Bitis Saati">
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time v-model="appointmentEnd" format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Appointment Send E-Mail ? -->
        <q-checkbox
          v-model="appointmentSendEmail"
          label="E-Posta Gonder"
          color="teal"
        />

        <!-- Appointment Send Sms ? -->
        <q-checkbox
          v-model="appointmentSendSms"
          label="SMS Gonder"
          color="teal"
        />
      </q-form>
    </q-card-section>

    <!-- Submit Button -->
    <q-card-actions align="right" class="text-primary">
      <q-btn v-close-popup flat label="Vazgec" color="red" />
      <q-btn
        v-close-popup
        flat
        label="Kaydet"
        color="secondary"
        @click="onSubmit"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, inject } from 'vue'
import axios from 'axios'
import moment from 'moment'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'
export default {
  setup() {
    const $q = useQuasar()
    const emitter = inject('emitter')

    // appointment form inputs
    const customerId = ref(null)
    const appointmentType = ref(null)
    const appointmentDate = ref(null)
    const appointmentStart = ref(null)
    const appointmentEnd = ref(null)
    const appointmentSendEmail = ref(true)
    const appointmentSendSms = ref(true)
    const customerOpt = ref([])
    const activeSubscriptionInfo = ref(null)
    const appointmentOpt = ref([])

    return {
      customerId,
      appointmentType,
      appointmentDate,
      appointmentStart,
      appointmentEnd,
      appointmentSendEmail,
      appointmentSendSms,
      customerOpt,
      appointmentOpt,
      activeSubscriptionInfo,

      filterFn(val, update) {
        update(() => {
          if (val.length > 2) {
            customerOpt.value.length = 0
            axios.get(`/customers/search?name=${val}`).then((response) => {
              customerOpt.value = response.data
            })
          }
        })
      },
      onCustomerSelect(text) {
        // if 'text' is the name of any customer, it is selected
        customerOpt.value.forEach((customer) => {
          if (customer.name === text) {
            console.log('Customer Selected : ' + JSON.stringify(customer))

            customerId.value = customer.id
            // Clear appointment options
            appointmentOpt.value.length = 0

            // Add introduction type by default
            appointmentOpt.value.push({
              label: 'Tanisma',
              value: 'INTRODUCTION',
            })

            // If there is no active subscriptions, display information message
            if (customer.activeSubscriptions.length === 0) {
              activeSubscriptionInfo.value =
                "Danisanin aktif paketi bulunamadi. Sadece 'tanisma' randevusu verilebilir."
            }

            // Iterate active subscriptions and update possible appointment types
            customer.activeSubscriptions.forEach((subscription) => {
              activeSubscriptionInfo.value =
                'Danisanin aktif paketi : ' + subscription.subscriptionTitle

              if (
                subscription.limits['REGIME_SESSION'] &&
                subscription.limits['REGIME_SESSION'] > 0
              ) {
                appointmentOpt.value.push({
                  label: 'Diyet Seansi',
                  value: 'REGIME_SESSION',
                })
              }

              if (
                subscription.limits['REGIONAL_LOSS'] &&
                subscription.limits['REGIONAL_LOSS'] > 0
              ) {
                appointmentOpt.value.push({
                  label: 'Bolgesel Zayiflama',
                  value: 'REGIONAL_LOSS',
                })
              }
            })
          }
        })
      },
      onSubmit() {
        let appDate = moment(appointmentDate.value, 'DD-MM-YYYY')
        let startTime = moment(appointmentStart.value, 'HH:mm')
        let endTime = moment(appointmentEnd.value, 'HH:mm')

        appDate.set({
          hour: startTime.get('hour'),
          minute: startTime.get('minute'),
        })

        axios
          .post('/appointments/', {
            customerId: customerId.value,
            appointmentType: appointmentType.value.value,
            appointmentStart: appDate.toISOString(),
            appointmentEnd: appDate
              .set({
                hour: endTime.get('hour'),
                minute: endTime.get('minute'),
              })
              .toISOString(),
            sendEmail: appointmentSendEmail.value,
            sendSms: appointmentSendSms.value,
          })
          .then(() => {
            $q.notify(notify.success('Randevu olusturuldu.'))
            emitter.emit(eventNames.REFRESH_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu olusturulamadi.'))
          })
      },
    }
  },
}
</script>
